/**
 * Render locally echoed Telnet input with basic line editing.
 * Keep track of typed characters so Backspace does not erase the remote prompt.
 */
export function createTelnetInputEcho() {
  let lineLength = 0;

  return {
    push(data) {
      const input = String(data ?? '');
      let output = '';

      for (let index = 0; index < input.length; index += 1) {
        const character = input[index];

        if (character === '\x1b') {
          // Preserve terminal navigation keys without counting their escape
          // sequence as visible input characters.
          if (input[index + 1] === '[') {
            let end = index + 2;
            while (end < input.length && !(input[end] >= '@' && input[end] <= '~')) end += 1;
            output += input.slice(index, Math.min(end + 1, input.length));
            index = Math.min(end, input.length - 1);
          } else if (index + 1 < input.length) {
            output += input.slice(index, index + 2);
            index += 1;
          } else {
            output += character;
          }
        } else if (character === '\r' || character === '\n') {
          output += '\r\n';
          lineLength = 0;
          if (character === '\r' && input[index + 1] === '\n') index += 1;
        } else if (character === '\b' || character === '\x7f') {
          if (lineLength > 0) {
            output += '\b \b';
            lineLength -= 1;
          }
        } else {
          output += character;
          if (character >= ' ' && character !== '\x7f') lineLength += 1;
        }
      }

      return output;
    },

    reset() {
      lineLength = 0;
    },
  };
}

/** xterm sends Backspace as DEL; the openHASP console expects ASCII BS. */
export function normalizeTelnetInput(data) {
  return String(data ?? '').replace(/\x7f/g, '\b');
}
